import { useEffect, useState } from "react";
import {
  ClearButton,
  CloseImg,
  CommonFlex,
  DropdownIndicatorIcon,
  DropdownTrigger,
  FilterLabel,
  InputWithLabelSection,
  PopoverCloseButton,
  PopoverWrapper,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  SingleFilterContainer
} from "../../styledComponents/common";
import CrossIcon  from "../../assets/img/icons/cross_black.svg";


const GenericPopoverModal = ({ isOpen, onClose, anchorRef, children, width = "250px" }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  useEffect(() => {
    const updatePosition = () => {
      const rect = anchorRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom,
        left: rect.left,
      });
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);
    
    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [isOpen, anchorRef]);

  if (!isOpen) return null;


  return (
    <PopoverWrapper onClick={onClose}>
      <PopoverContent top={position.top} left={position.left} width={width} onClick={(e) => e.stopPropagation()}>
        <PopoverHeader>
          <PopoverCloseButton onClick={onClose}>
            <CloseImg src={CrossIcon} alt="" />
          </PopoverCloseButton>
        </PopoverHeader>
        <PopoverBody  gap="16px">{children}</PopoverBody>
      </PopoverContent>
    </PopoverWrapper>

  );
};

export default GenericPopoverModal;